<script setup lang="ts">
import Login from "@client/components/core/Login.vue";
import Register from "@client/components/core/Register.vue";
const showShowAnyModal = defineModel({ type: Boolean, required: true });
const currentComponent = ref("login");
</script>
<template>
	<Login
		v-if="currentComponent === 'login'"
		v-model:show="showShowAnyModal"
		v-model:component="currentComponent" />
	<Register
		v-if="currentComponent === 'register'"
		v-model:show="showShowAnyModal"
		v-model:component="currentComponent" />
</template>
